import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { styled } from 'opensolar-ui'
import { memo } from 'react'
import { Placeholder } from 'react-admin'
import { headCells, MPO_ACTION_COLUMN_STYLE, MPO_TABLE_MIN_WIDTH } from './TableHeader'

const StyledTable = styled(Table)({
  tableLayout: 'fixed',
  width: '100%',
  minWidth: MPO_TABLE_MIN_WIDTH,
})

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
}))

const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontSize: '13px',
  fontWeight: 500,
  color: theme.palette.grey[900],
  padding: '12px 16px',
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
  verticalAlign: 'top',
}))

const BodyCell = styled(TableCell)(({ theme }) => ({
  padding: '12px 16px',
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
  verticalAlign: 'top',
}))

const NB_FAKE_ROWS = 5

const ProjectTableSkeleton = () => {
  return (
    <StyledTable size="small">
      <StyledTableHead>
        <TableRow>
          {headCells.map((headCell) => (
            <HeaderCell key={headCell.source} variant="head" style={{ width: headCell.width }}>
              <Placeholder />
            </HeaderCell>
          ))}
          <HeaderCell variant="head" style={MPO_ACTION_COLUMN_STYLE}>
            <Placeholder />
          </HeaderCell>
        </TableRow>
      </StyledTableHead>
      <TableBody>
        {Array.from({ length: NB_FAKE_ROWS }, (_, i) => (
          <TableRow key={i} style={{ opacity: 1 / (i + 1) }}>
            {headCells.map((headCell) => (
              <BodyCell key={headCell.source} style={{ width: headCell.width }}>
                <Placeholder />
              </BodyCell>
            ))}
            <BodyCell style={MPO_ACTION_COLUMN_STYLE}>
              <Placeholder />
            </BodyCell>
          </TableRow>
        ))}
      </TableBody>
    </StyledTable>
  )
}

export default memo(ProjectTableSkeleton)
